module.exports = "https://bin.bnbstatic.com/_next/static/images/Vlad Golub-ea59c39ed21a990271cb135dc4a7bf67.jpg";